import { c as _c } from "react/compiler-runtime";
import { Toaster as Sonner } from "sonner";
type ToasterProps = React.ComponentProps<typeof Sonner>;
const toastClassName = "group toast group-[.toaster]:rounded-[var(--surface-overlay-radius)] group-[.toaster]:border-[length:var(--surface-overlay-border-width)] group-[.toaster]:border-comp-border-subtle group-[.toaster]:bg-comp-overlay group-[.toaster]:text-comp-text-primary group-[.toaster]:shadow-comp-overlay";
const actionButtonClassName = "group-[.toast]:border-transparent group-[.toast]:bg-comp-accent group-[.toast]:text-comp-accent-foreground";
const cancelButtonClassName = "group-[.toast]:[border-width:var(--border-hairline)] group-[.toast]:border-[var(--control-surface-border)] group-[.toast]:bg-[var(--control-surface-bg)] group-[.toast]:text-[var(--control-surface-text)] group-[.toast]:[box-shadow:var(--control-surface-shadow)]";
const closeButtonClassName = "group-[.toast]:border-comp-border-subtle group-[.toast]:bg-comp-overlay group-[.toast]:text-comp-text-tertiary group-[.toast]:shadow-surface-sm";
const errorToastClassName = "group-[.toaster]:border-destructive-border group-[.toaster]:bg-destructive-subtle group-[.toaster]:text-destructive-subtle-foreground [&_[data-description]]:text-destructive-subtle-foreground [&_[data-icon]]:text-destructive-subtle-foreground";
const Toaster = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      classNames: {
        toast: toastClassName,
        description: "group-[.toast]:text-comp-text-tertiary",
        actionButton: actionButtonClassName,
        cancelButton: cancelButtonClassName,
        closeButton: closeButtonClassName,
        success: "[&_[data-icon]]:text-success",
        error: errorToastClassName,
        info: "[&_[data-icon]]:text-info",
        warning: "[&_[data-icon]]:text-warning",
        default: "[&_[data-icon]]:text-comp-text-tertiary"
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <Sonner theme="light" className="toaster group" toastOptions={t1} {...props} />;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Toaster };